<template>
  <div class="helper-card" >
     <div class="img-container" :style="{ 'background': 'url('+ image +')' } ">
        <div class="overlay"></div>
    </div>
    <div class="text-container">
        <h4>{{title}}</h4>
        <p>{{desc}}</p>
        <button class="btn helper-card-button" type="button" @click="func()" >
            <p>{{buttontext}}</p>
        </button>
    </div>  
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  components: {
  },
  methods: {
    getHelp(){
      return alert("Help giveth!");
    }
  },
  props: ['title', 'desc', 'buttontext', 'func', 'image']
};
</script>

<style lang="scss" scoped>
// @import "../../../styles.scss";

    .helper-card{
        position: relative;
        width: 32%;
        height: 150px;
        min-width: 200px;
        display: flex;
        margin-bottom: 20px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
    }
    
    .general-info .helper-card{
        height: 150px;
        margin-top: 25px;
    }

    .helper-card .img-container{
        background-size: cover !important;
        background-position: center center !important;
    }

    .helper-card .img-container,
    .helper-card .text-container{
        position: relative;
        width: 55%;
        height: 100%;
        justify-content: center;
        border-style: round;
        border-radius: 6px 0 0 6px;
    }
    .helper-card .img-container{
        width: 45%;
    }

    .helper-card .text-container{
        border-radius: 0 6px 6px 0;
        background: $sovis-white;
        padding: 5px 10px;
    }

    .helper-card .text-container h4{
        color: $semi-title-color;
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 15px;
        text-align: initial;
    }

    .helper-card .text-container p{
        color: $light-gray-color;
        font-weight: normal;
        font-size: 10px;
        text-align: justify;
    }

    .helper-card .img-container .overlay{
        width: 100%;
        height: 100%;
        // background-color: $overlay-color;
        opacity: 0.5;
        position: absolute;
        top: 0;
    }

    .helper-card .text-container .helper-card-button{
        position: absolute;
        border-style: round;
        border-radius: 6px;
        padding: 7px 20px;
        @include gradient-button();
            bottom: 5px;
            right: 5px;
        > p{
            margin-bottom: 0;
            color: $sovis-white;
        }
    }

  
@media only screen and (max-width: 1300px) {

  .helper-card {
    height: 200px;
  }

  .text-container {
    > h4 {
      font-size: 16px !important;
      text-align: initial;
    }
    
    > p {
      font-size: 10px !important;
      text-align: justify;
    }
  }
}
  
@media only screen and (max-width: 960px) {

  .helper-card {
    width: 48%;
    height: 170px;
  }

}

@media only screen and (max-width: 680px) {

  .text-container {
    > h4 {
      font-size: 14px !important;
      text-align: initial;
    }
    
    > p {
      font-size: 9px !important;
      text-align: justify;
    }
  }
    
  .helper-card {
    width: 100%;
    height: 170px;
  }

}

</style>
